import { Card, CardContent } from "@/components/ui/card";
import { Quote } from "lucide-react";

const testimonials = [
  {
    name: "Ana Carolina Silva",
    role: "Empreendedora",
    quote:
      "Finalmente consegui organizar as finan\u00e7as do meu neg\u00f3cio e pessoais em um s\u00f3 lugar. O DRE para MEI \u00e9 incr\u00edvel!",
    initials: "AC",
  },
  {
    name: "Rafael Santos",
    role: "Desenvolvedor",
    quote:
      "Uso o Next AI Finance para controlar meus gastos e metas. Em 3 meses, consegui economizar 30% a mais do que antes.",
    initials: "RS",
  },
  {
    name: "Juliana Oliveira",
    role: "Professora",
    quote:
      "A interface \u00e9 super intuitiva. Compartilho a conta com meu marido e agora planejamos nossas finan\u00e7as juntos.",
    initials: "JO",
  },
];

export function TestimonialsSection() {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            O que nossos usu&aacute;rios dizem
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            Hist&oacute;rias reais de quem j&aacute; transformou sua vida financeira.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial) => (
            <Card
              key={testimonial.name}
              className="hover:shadow-lg transition-shadow"
            >
              <CardContent className="p-6 space-y-4">
                <Quote className="h-6 w-6 text-primary/40" />

                <p className="text-muted-foreground text-sm leading-relaxed italic">
                  &ldquo;{testimonial.quote}&rdquo;
                </p>

                <div className="flex items-center gap-3 pt-2">
                  <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
                    <span className="text-sm font-semibold text-primary">
                      {testimonial.initials}
                    </span>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground">
                      {testimonial.name}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      {testimonial.role}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
